module.exports = __webpack_public_path__ + "img/location-body-pattern.1b7f94aa.png";